import axios from '../../utils/http/http';
import { triggerNotification } from '../../utils/NotificationContext';
const flow = 'BulkVoting';

//! v2 endpoint for chunking
export const fetchVotingDataV2 = async (
  bu,
  userId,
  userLevel,
  pageNumber,
  pageSize,
  region = null,
  cycleId,
  customer = null,
  taskName = null
) => {
  try {
    const API_BASE_URL = '/tpo/voting/getTPOSKUBusinessLevel';
    let API_URL = '';
    const modifiedUserLevel = userLevel <= 0 ? 999 : userLevel;
    if (customer) {
      API_URL = `${API_BASE_URL}/${bu}/${userId}/${modifiedUserLevel}/${pageNumber}/${pageSize}?customer=${customer}&cycleId=${cycleId}`;
    } else if (region) {
      API_URL = `${API_BASE_URL}/${bu}/${userId}/${modifiedUserLevel}/${pageNumber}/${pageSize}?region=${region}&cycleId=${cycleId}`;
    } else {
      API_URL = `${API_BASE_URL}/${bu}/${userId}/${modifiedUserLevel}/${pageNumber}/${pageSize}?cycleId=${cycleId}`;
    }
    const response = await axios.getRequest(`${API_URL}&taskName=${taskName}`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchRecommendationOptions = async (BU) => {
  try {
    const response = await axios.getRequest(`/tpo/voting/getRecommendation/${encodeURIComponent(BU)}`);

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUsers = async (BU, userLevel) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/getBUUsers/${encodeURIComponent(BU)}/${userLevel ? userLevel : 999}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const getStepStatus = async (userId, userRole, bu, cycleId) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/getUserLevel/${userId}/${userRole}/${encodeURIComponent(bu)}/${cycleId}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const saveVotingData = async (obj) => {
  try {
    const response = await axios.postRequest(`/tpo/voting/addVote`, obj);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const getRegionOptions = async (userId, userLevel, bu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/getAllRegionsForUser/${userId}/${userLevel}?buName=${encodeURIComponent(bu)}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
/**
 * The function fetches SKU level comments for a specific cycle, user, and user level using an
 * asynchronous GET request.
 * @param cycleSKUKey - The `cycleSKUKey` parameter represents the key for a specific cycle and SKU
 * combination. It is used to identify the specific cycle and SKU for which comments are being fetched.
 * @param userID - The `userID` parameter in the `fetchSKULevelComments` function represents the unique
 * identifier of the user for whom you want to fetch comments. It is used to specify which user's
 * comments to retrieve from the server.
 * @param userLevel - The `userLevel` parameter in the `fetchSKULevelComments` function represents the
 * level of the user for whom you want to fetch comments. It is used to specify the user level for
 * filtering comments.
 * @returns The function `fetchSKULevelComments` is returning the response from the axios get request.
 */
export const fetchSKULevelComments = async (cycleSKUKey, userID, userLevel) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/getAllUsersCommentRecom/${cycleSKUKey}/${userID}/${userLevel}`
    );
    const { error } = response;
    if (error) {
      triggerNotification('Something went wrong', 'error');
    }
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

// Upload APIs for Voting

export const bulkUploadFile = async (formData, onUploadProgress, region = null) => {
  try {
    const API_BASE_URL = '/tpo/voting/bulkupload';
    const response = await axios.postRequest(API_BASE_URL, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress
    });
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Bulk Upload Failed!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUploadsInProgress = async (selectedBu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/bulkUpload/uploadStatusByFlow/${flow}?buName=${encodeURIComponent(selectedBu)}`
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUniqueL7Customers = async (selectedCycleId, selectedBu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/UniqueL7CustomerList/${selectedCycleId}/${encodeURIComponent(selectedBu)}`
    );
    return response;
  } catch (error) {
    console.log(error);
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUploadsInProgressByUserId = async (userName, selectedBu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/bulkUpload/uploadStatus/${userName}?buName=${encodeURIComponent(selectedBu)}&flow=${flow}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

// SKU MODAL-CY LY Graph

export const fetchCYLYData = async (tpoSKUKey, selectedBu, selectedCycleId) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/cyLYGraph/${encodeURIComponent(selectedBu)}/${tpoSKUKey}?cycleId=${selectedCycleId}`
    );
    const { error } = response;
    if (error) {
      triggerNotification('Something went wrong', 'error');
    }
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

// SKU MODAL-Product Attribute

export const fetchProductAttributes = async (tpoSKU, selectedCycleId) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/productAttribute/${tpoSKU}?cycleId=${selectedCycleId}`
    );
    const { error } = response;
    if (error) {
      triggerNotification('Something went wrong', 'error');
    }
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

// SKU MODAL-Product Growth

export const fetchProductGrowth = async (tpoSKUKey, selectedBu, selectedCycleId) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/productGrowth/${tpoSKUKey}?buName=${encodeURIComponent(selectedBu)}&cycleId=${selectedCycleId}`
    );
    const { error } = response;
    if (error) {
      triggerNotification('Something went wrong', 'error');
    }
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

// SKU MODAL-Product KPI

export const fetchProductKPI = async (tpoSKUKey, selectedBu, selectedCycleId) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/productKPI/${tpoSKUKey}?buName=${encodeURIComponent(selectedBu)}&cycleId=${selectedCycleId}`
    );
    const { error } = response;
    if (error) {
      triggerNotification('Something went wrong', 'error');
    }
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

// SKU MODAL-Product Breakdown

export const fetchProductRegionBreakdown = async (tpoSKUKey, selectedBu, selectedCycleId) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/productRegionBreakdown/${tpoSKUKey}?buName=${encodeURIComponent(selectedBu)}&cycleId=${selectedCycleId}`
    );
    const { error } = response;
    if (error) {
      triggerNotification('Something went wrong', 'error');
    }
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchProductChannelBreakdown = async (tpoSKUKey, selectedBu, selectedCycleId) => {
  try {
    const response = await axios.getRequest(
      `/tpo/voting/productChannelBreakdown/${tpoSKUKey}?buName=${encodeURIComponent(selectedBu)}&cycleId=${selectedCycleId}`
    );
    const { error } = response;
    if (error) {
      triggerNotification('Something went wrong', 'error');
    }
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
